// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/search/restaurant_result.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_entity_place } from "../entity/place_pb";

/**
 * Describes the file proto/model/search/restaurant_result.proto.
 */
export const file_proto_model_search_restaurant_result = /*@__PURE__*/
  fileDesc("Cipwcm90by9tb2RlbC9zZWFyY2gvcmVzdGF1cmFudF9yZXN1bHQucHJvdG8SBmNhcm1lbiI1ChBSZXN0YXVyYW50UmVzdWx0EiEKCnJlc3RhdXJhbnQYASABKAsyDS5jYXJtZW4uUGxhY2VCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_proto_model_entity_place]);

/**
 * Describes the message carmen.RestaurantResult.
 * Use `create(RestaurantResultSchema)` to create a new message.
 */
export const RestaurantResultSchema = /*@__PURE__*/
  messageDesc(file_proto_model_search_restaurant_result, 0);

